import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';


const CustomImage = ({ imageName }) => {

    const loginState = useSelector(state => state.currentLogin); //consolidated new Redux login state
    const [imgSrc, setImgSrc] = useState(null);

    useEffect(() => {
        
        axios.get(`/images/${imageName}`, { headers: { Authorization: loginState.token}, responseType: 'arraybuffer' })
        .then(response => {
            const base64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '',),);  //converts axios image extraction to <img src readable format
            setImgSrc("data:;base64," + base64 );
        })
        .catch(error => {
            console.log('[Error] getImage: ', error.message);
            console.log('*** getImage: ', `/images/${imageName}`);
            if(error.response.status === 401){  //If Error 401 means user is not authorised
                console.log('{*********} Error 401');
                //Alert.alert('[Error] 401 Unauthorized');
            }
            if(error.response.status === 403){  //If Error 403 means user is not authorised or Token has expired, route back to login screen...
                console.log('{*********} Error 403 found - Logging out User...');
                //signOut();
            }
        });

    }, [loginState, imageName]);

    return(
        <>
            <img className="gmarkerinfoimage" src={imgSrc} alt="site view" />
        </>
    );

}

export default CustomImage;
